import React from "react";
import { CoverageComponentProps } from "./types";
import { useSharedStyles } from "../../styles/sharedStyles";
import HookFormSelectField from "../../../../components/controls/HookFormSelectField";
import TextInputField from "../../../../components/controls/TextInputField";
import { Text } from "@fluentui/react-components";

const MtplCoverage: React.FC<CoverageComponentProps<"mtpl">> = ({
  config,
  onConfigChange,
  premium,
  onPremiumChange,
  t,
  form,
}) => {
  const classes = useSharedStyles();

  return (
    <>
      {/* First row: Insurance limit (LIMITY) and Deductible (SPOL_MTPL) */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "15px",
          marginBottom: "8px",
        }}
      >
        <HookFormSelectField
          label={t("ila.coverages.mtpl.limitLabel")}
          name="mtplLimit"
          form={form}
          options={[
            { value: "50000000", label: "50 000 000 Kč" },
            { value: "70000000", label: "70 000 000 Kč" },
            { value: "100000000", label: "100 000 000 Kč" },
            { value: "200000000", label: "200 000 000 Kč" },
          ]}
          required
          value={config.limit?.toString() || ""}
          onChange={(e) => onConfigChange({ limit: parseInt(e.target.value) })}
        />

        <HookFormSelectField
          label={t("ila.coverages.mtpl.deductibleLabel")}
          name="mtplDeductible"
          form={form}
          options={[
            { value: "25000", label: "25 000 Kč" },
            { value: "9999", label: "9 999 Kč" },
          ]}
          value={config.deductible?.toString() || ""}
          onChange={(e) =>
            onConfigChange({ deductible: parseInt(e.target.value) })
          }
          required={false}
        />
      </div>

      {/* Second row: Commercial discount (SLE170) and Voucher code (VOUCHER) */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "15px",
        }}
      >
        <TextInputField
          label={t("ila.coverages.mtpl.commercialDiscountLabel")}
          name="mtplCommercialDiscount"
          form={form}
          type="number"
          min={0}
          max={100}
          value={config.commercialDiscount?.toString() || ""}
          onChange={(e) =>
            onConfigChange({
              commercialDiscount: parseInt(e.target.value || "0"),
            })
          }
          placeholder={t("ila.coverages.mtpl.commercialDiscountPlaceholder")}
          contentAfter="%"
        />

        <TextInputField
          label={t("ila.coverages.mtpl.voucherCodeLabel")}
          name="mtplVoucherCode"
          form={form}
          type="text"
          value={config.voucherCode || ""}
          onChange={(e) => onConfigChange({ voucherCode: e.target.value })}
          placeholder={t("ila.coverages.mtpl.voucherCodePlaceholder")}
        />
      </div>
    </>
  );
};

export default MtplCoverage;
